import script from "./ProviderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderTable.vue?vue&type=script&setup=true&lang=js"

import "./ProviderTable.vue?vue&type=style&index=0&id=2ab44740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab44740"]])

export default __exports__